import React from 'react';
import PropTypes from 'prop-types';

export default class HeaderCollapseOption extends React.Component {

  render() {
    return (
      <div className="pull-right header-dropdown">
        <a onClick={this.props.onClick}>
          <i className="material-icons">{ this.props.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}</i>
        </a>
      </div>
    );
  }

}

HeaderCollapseOption.propTypes = {
  collapsed: PropTypes.bool,
  onClick: PropTypes.func,
};

HeaderCollapseOption.defaultProps = {
  collapsed: true,
  onClick: () => {},
};



// WEBPACK FOOTER //
// ./src/app/shared/components/HeaderCollapseOption.js